/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CompliancePostureVisibilityResponse {
    getFixupPrototypeFunction() { return CompliancePostureVisibilityResponse.fixupPrototype; }

    static newInstance(model: Partial<CompliancePostureVisibilityResponse>): CompliancePostureVisibilityResponse {
        let obj = Object.assign(new CompliancePostureVisibilityResponse(), model);
        CompliancePostureVisibilityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CompliancePostureVisibilityResponse>): CompliancePostureVisibilityResponse {
        if (!model) return null;
        return CompliancePostureVisibilityResponse.newInstance(<CompliancePostureVisibilityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CompliancePostureVisibilityResponse) {
        if (!obj) return;

        models.CompliancePostureVisibilityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CompliancePostureVisibilityResponse): boolean {
        Object.setPrototypeOf(obj, CompliancePostureVisibilityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * success
     */
    status: string;

    /**
     * Compliance Standard Visibility For Cloud Account
     */
    message: string;

    /**
     * data for compliance posture visibility
     */
    data: any;

}
